import { createSelector, createSlice } from "@reduxjs/toolkit";
import { createBaseSelector, registerSlice } from "shared/lib/redux";

export type AirCardDeleteModalState = boolean;

const initialAirCardDeleteModalState: AirCardDeleteModalState = false;

const airCardDeleteModalSlice = createSlice({
  name: "AirCardDeleteModal",
  initialState: initialAirCardDeleteModalState,
  reducers: {
    openDeleteCardModalAction: () => {
      return true;
    },
    closeDeleteModalAction: () => {
      return false;
    },
  },
});

const airCardDeleteModalBaseSelector = createBaseSelector(airCardDeleteModalSlice);

registerSlice([airCardDeleteModalSlice]);

export const airCardDeleteModalStore = {
  actions: airCardDeleteModalSlice.actions,
  selectors: {
    airCardDeleteModal: createSelector(airCardDeleteModalBaseSelector, (s) => s),
  },
};
